import listActions from 'src/modules/recyclingMaterials/list/recyclingMaterialsListActions';
import RecyclingMaterialsService from 'src/modules/recyclingMaterials/recyclingMaterialsService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import Message from 'src/view/shared/message';
import { navigateTo } from 'src/view/shared/routes/helpers';

const prefix = 'RECYCLINGMATERIALS_DESTROY';

const recyclingMaterialsDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: recyclingMaterialsDestroyActions.DESTROY_STARTED,
      });

      await RecyclingMaterialsService.destroyAll([id]);

      dispatch({
        type: recyclingMaterialsDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(i18n('entities.recyclingMaterials.destroy.success'));

      dispatch(listActions.doFetchCurrentFilter());

      navigateTo('/library/recycling-materials');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: recyclingMaterialsDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: recyclingMaterialsDestroyActions.DESTROY_ALL_STARTED,
      });

      await RecyclingMaterialsService.destroyAll(ids);

      dispatch({
        type: recyclingMaterialsDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(i18n('entities.recyclingMaterials.destroyAll.success'));

      navigateTo('/library/recycling-materials');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: recyclingMaterialsDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default recyclingMaterialsDestroyActions;
